import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import { getAnalytics as getAnalyticsApi } from "../../helpers/";

// constants
import { AnalyticsActionTypes } from "./constants";
import { getAnalyticsError, getAnalyticsSuccess } from "./actions";

interface AnalyticsData {
  payload: {
    country?: string;
    seller?: string;
    boutique?: string;
    startDate?: any;
    endDate?: any;
  };
  type: string;
}

function* getAnalytics({
  payload: { country, seller, boutique, startDate, endDate },
}: AnalyticsData): SagaIterator {
  try {
    const response = yield call(getAnalyticsApi, {
      country,
      seller,
      boutique,
      startDate,
      endDate,
    });
    if (response?.status === 403 || response?.__handled403) {
      yield put(
        getAnalyticsError(AnalyticsActionTypes.GET_ANALYTICS, "Forbidden")
      );
      return;
    }
    const analytics = response.data;
    yield put(
      getAnalyticsSuccess(AnalyticsActionTypes.GET_ANALYTICS, analytics)
    );
  } catch (error: any) {
    yield put(getAnalyticsError(AnalyticsActionTypes.GET_ANALYTICS, error));
  }
}

export function* watchGetAnalytics() {
  yield takeEvery(AnalyticsActionTypes.GET_ANALYTICS, getAnalytics);
}

function* analyticsSaga() {
  yield all([fork(watchGetAnalytics)]);
}

export default analyticsSaga;
